// 引入封装axios服务
import request from '@/utils/request'
// request 二次处理
// import awaitWrap from '@/utils/awaitWrap'
const baseURL = process.env.VUE_APP_BASE_API
// const baseURL = 'http://192.168.156.37:8080/' // 关洪颜

/**
 * 获取json 新对象，去掉空字段
 * @param {Object} data
 * @returns
 */
export function getClearJson(data) {
  const _data = {}
  for (const prop in data) {
    const item = data[prop]
    if (item !== undefined && item) {
      _data[prop] = item
    }
  }
  return _data
}
/**
 * requestB baserUrl重写
 * @param {Object} data
 * @returns
 */
const requestB = (data) => {
  return request({
    ...data,
    ...{
      baseURL
    }
  })
}

// 流程列表
export function getProcessionListData(data) {
  return requestB({
    url: '/processRule/queryRuleList',
    method: 'post',
    data
  })
}

// 表单树
export function getFormTree(data) {
  return requestB({
    url: '/customer_form/tree',
    method: 'get',
    data
  })
}

// 新建流程  /processRule/addRule

export function createNewProcession(data) {
  return requestB({
    url: '/processRule/addRule',
    method: 'post',
    data
  })
}

export function editProcession(data) {
  return requestB({
    url: '/processRule/updRule',
    method: 'post',
    data
  })
}

// 流程规则详情页
export function processionDetail(id) {
  return requestB({
    url: `/processRule/getRuleDetail?id=${id}`,
    method: 'post'
  })
}

// 查询流程【流转】实例详情
export function processInstance(procInsId) {
  return requestB({
    url: `/approve/query/detail/${procInsId}`,
    method: 'get'
  })
}

// 员工组织架构树形结构查询  用户
export function getUserDepartmentTree(data) {
  return requestB({
    url: '/common/getUserDepartmentTree',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 员工组织架构树形结构查询  用户
export function getKaUserList(data) {
  return requestB({
    url: '/scrm/quotation/queryUser',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 角色查询
export function getRoleList(data) {
  return requestB({
    url: '/role/queryList',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
// 用户组列表
export function userGroupList(data) {
  return requestB({
    url: '/userGroup/list',
    method: 'post',
    data
  })
}

// 岗位 /job/list
export function getJobList(data) {
  return requestB({
    url: '/job/list',
    method: 'post',
    data
  })
}
// 部门 组织
export function getDepartmentList(data) {
  return requestB({
    url: '/common/getDepartmentTree',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getFlowHistory(data) {
  return requestB({
    url: '/taskManager/finishedHistoryList',
    method: 'post',
    data
  })
}
//  条件分值 字段信息
export function getfieldList(data) {
  return requestB({
    url: `/form/structure/column/conditionList?formId=${data}`,
    method: 'get'
  })
}

// 删除流程规则
export function delRule(id) {
  return requestB({
    url: `/processRule/delRule?id=${id}`,
    method: 'post'

  })
}

// 流程记录
export function getProcessRecord(data) {
  return requestB({
    url: `/flowMonitor/process/record/`,
    method: 'post',
    data
  })
}

// 获取审批流程列表
export function getApprovalList(data) {
  return requestB({
    url: `/flowMonitor/approvalList`,
    method: 'post',
    data
  })
}

// 根据表单id查询表单触发动作
export function GetTriggerByFormId(params) {
  return requestB({
    url: `/processRule/getTriggerByFormId`,
    method: 'get',
    params
  })
}

// 根据用户id查询用户数据
export function getUserNameList(data) {
  return requestB({
    url: `/common/getUserNameList`,
    method: 'post',
    data
  })
}

// 获取所有部门
export function getAllDepartmentTree() {
  return requestB({
    url: `/common/getDepartmentTree`,
    method: 'post',
    data: { 'withAppVisible': false }
  })
}
